import { useEffect, useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { router } from "@/app/router";
import { queryClient } from "@/lib/query-client";

async function enableMocking(): Promise<void> {
  if (import.meta.env.MODE !== "development") return;
  // Opt-out: setting VITE_USE_MSW=false in .env.development.local disables
  // MSW so the SPA talks to the real backend at VITE_API_BASE_URL. The
  // default (unset) keeps MSW on for backward compatibility with the
  // "frontend only" workflow that does not need the backend running.
  if (import.meta.env.VITE_USE_MSW === "false") return;
  const { worker } = await import("@/mocks/browser");
  await worker.start({ onUnhandledRequest: "bypass" });
}

export function Providers() {
  const [ready, setReady] = useState(import.meta.env.MODE !== "development");

  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    void enableMocking().finally(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, [ready]);

  if (!ready) {
    return (
      <div className="flex min-h-full items-center justify-center p-6 text-sm text-muted-foreground">
        Đang khởi động...
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-center" />
    </QueryClientProvider>
  );
}
